'use client';

import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import { Clock } from 'lucide-react';
import { cn } from '@/lib/utils';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
const triggerCls = 'flex w-full items-center gap-2 px-4 py-3 text-base border rounded-lg bg-background text-left cursor-pointer transition-colors hover:border-primary focus:outline-none focus:ring-2 focus:ring-primary';

// Opening-hours-friendly 30-minute slots (08:00–19:00).
const SLOTS: string[] = (() => {
  const s: string[] = [];
  for (let h = 8; h <= 19; h++) {
    s.push(`${String(h).padStart(2, '0')}:00`);
    if (h < 19) s.push(`${String(h).padStart(2, '0')}:30`);
  }
  return s;
})();
type Props = {
  name: string;
  id?: string;
  required?: boolean;
  placeholder?: string;
};

/** shadcn-style time picker: opens a list of half-hour slots on click and
 * carries the chosen value (HH:mm) in a hidden input for Netlify capture. */
export function TimePickerField(t0) {
  const $ = _c(24);
  const {
    name,
    id,
    required: t1,
    placeholder
  } = t0;
  const required = t1 === undefined ? false : t1;
  const [value, setValue] = React.useState("");
  const [open, setOpen] = React.useState(false);
  const t2 = !value && "text-muted-foreground";
  let t3;
  if ($[0] !== t2) {
    t3 = cn(triggerCls, t2);
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Clock className="size-5 shrink-0 text-muted-foreground" />;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const t5 = value || placeholder || "\u2014";
  let t6;
  if ($[3] !== t5) {
    t6 = <span className="flex-1">{t5}</span>;
    $[3] = t5;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] !== t3 || $[6] !== t6) {
    t7 = <PopoverTrigger asChild={true}><button type="button" className={t3}>{t4}{t6}</button></PopoverTrigger>;
    $[5] = t3;
    $[6] = t6;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== value) {
    t8 = SLOTS.map(s => <button key={s} type="button" onClick={() => {
      setValue(s);
      setOpen(false);
    }} className={cn("w-full rounded-md px-2 py-1.5 text-center text-sm transition-colors", s === value ? "bg-primary font-semibold text-primary-foreground" : "hover:bg-accent")}>{s}</button>);
    $[8] = value;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== t8) {
    t9 = <PopoverContent className="w-32 p-1" align="start"><div className="max-h-56 overflow-y-auto">{t8}</div></PopoverContent>;
    $[10] = t8;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== open || $[13] !== t7 || $[14] !== t9) {
    t10 = <Popover open={open} onOpenChange={setOpen}>{t7}{t9}</Popover>;
    $[12] = open;
    $[13] = t7;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== id || $[17] !== name || $[18] !== required || $[19] !== value) {
    t11 = <input type="text" name={name} id={id} value={value} required={required} onChange={_temp} tabIndex={-1} aria-hidden={true} className="sr-only" />;
    $[16] = id;
    $[17] = name;
    $[18] = required;
    $[19] = value;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t10 || $[22] !== t11) {
    t12 = <>{t10}{t11}</>;
    $[21] = t10;
    $[22] = t11;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  return t12;
}
function _temp() {}